import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Header.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    if (location.pathname !== "/") {
      navigate(`/#${sectionId}`);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
    setIsMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo" onClick={() => setIsMenuOpen(false)}>
            <h1 className="myanmar-text-bold">ရွှေဘုံစံ ပရင့်ဇက်(စ်)</h1>
            <span className="english-text">Shwe Bon San Princess</span>
          </Link>

          <nav className={`nav ${isMenuOpen ? "nav-open" : ""}`}>
            <ul>
              <li>
                <a
                  href="/#home"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("home");
                  }}
                  className="myanmar-text"
                >
                  ပင်မစာမျက်နှာ
                </a>
              </li>
              <li>
                <a
                  href="/#about"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("about");
                  }}
                  className="myanmar-text"
                >
                  ကျွန်ုပ်တို့အကြောင်း
                </a>
              </li>
              <li>
                <a
                  href="/#products"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("products");
                  }}
                  className="myanmar-text"
                >
                  ထုတ်ကုန်များ
                </a>
              </li>
              <li>
                <Link
                  to="/gallery"
                  onClick={() => setIsMenuOpen(false)}
                  className="myanmar-text"
                >
                  ဓာတ်ပုံများ
                </Link>
              </li>
              <li>
                <a
                  href="/#video"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("video");
                  }}
                  className="myanmar-text"
                >
                  ဗီဒီယို
                </a>
              </li>
              <li>
                <a
                  href="/#contact"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("contact");
                  }}
                  className="myanmar-text"
                >
                  ဆက်သွယ်ရန်
                </a>
              </li>
            </ul>
          </nav>

          <button className="menu-toggle" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
